/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Max_Rounds_DescInputs */



/**
* | output |
* | --- |
* | "preliminary rounds only, the final is not included; locked once check-in starts or the event reaches the VEKN calendar; never below the rounds already played" |
*
* @param {Og_Cfg_Max_Rounds_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_max_rounds_desc = /** @type {((inputs?: Og_Cfg_Max_Rounds_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Max_Rounds_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("rondes préliminaires uniquement, la finale n'est pas incluse ; verrouillé dès que le pointage commence ou que l'événement rejoint le calendrier VEKN ; jamais en dessous des rondes déjà jouées")
	if (locale === "es") return /** @type {LocalizedString} */ ("solo rondas preliminares, la final no está incluida; se bloquea en cuanto comienza el check-in o el evento llega al calendario VEKN; nunca por debajo de las rondas ya jugadas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("apenas rodadas preliminares, a final não está incluída; bloqueado assim que o check-in começa ou o evento chega ao calendário VEKN; nunca abaixo das rodadas já jogadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("solo round preliminari, la finale non è inclusa; si blocca all'avvio del check-in o quando l'evento raggiunge il calendario VEKN; mai al di sotto dei round già giocati")
	return /** @type {LocalizedString} */ ("preliminary rounds only, the final is not included; locked once check-in starts or the event reaches the VEKN calendar; never below the rounds already played")
});